/* Domain enums shared by API and apps (mirror the Prisma enums). */
export const SubscriptionStatus = ['invited', 'active', 'grace', 'read_only', 'suspended'];
export const SubscriptionType = ['paid_offline', 'gift', 'trial'];
export const PlatformRole = ['owner', 'admin', 'support', 'viewer'];
/** System tenant roles. Custom roles (Business plan) get their own keys. */
export const TenantRole = ['owner', 'admin', 'manager', 'member', 'guest'];
export const TenantStatus = ['active', 'suspended', 'pending_deletion', 'deleted'];
export const FontKey = ['jakarta', 'inter', 'manrope', 'dmsans', 'poppins'];
export const ThemeMode = ['light', 'dark', 'system'];
export const RadiusStyle = ['sharp', 'rounded', 'soft'];
export const DomainKind = ['subdomain', 'apex'];
export const DomainStatus = ['pending_dns', 'verifying', 'ssl_issuing', 'live', 'failed'];
export const UserStatus = ['invited', 'active', 'deactivated', 'pending_deletion', 'anonymized'];
export const InvitationStatus = ['pending', 'accepted', 'revoked', 'expired'];
export const InquiryStatus = ['new', 'contacted', 'approved', 'rejected'];
export const OfferLinkStatus = ['active', 'claimed', 'expired', 'revoked'];
export const OverrideScope = ['tenant', 'workspace'];
export const Priority = ['urgent', 'high', 'normal', 'low'];
export const CustomFieldType = [
    'text',
    'number',
    'currency',
    'dropdown',
    'labels',
    'date',
    'checkbox',
    'people',
    'url',
    'email',
    'phone',
    'progress',
    'rating',
];
export const ViewType = ['list', 'board', 'calendar', 'table', 'stickies'];
export const NotificationChannel = ['in_app', 'email', 'push'];
export const ExportStatus = ['queued', 'running', 'ready', 'failed', 'expired'];
export const JobStatus = ['running', 'ok', 'failed', 'skipped'];
export const ActorType = ['platform', 'tenant', 'system'];
/** Entitlement keys (PLAN §4). Limits use -1 for "Unlimited". */
export const LimitKeys = [
    'max_users',
    'max_workspaces',
    'max_projects',
    'max_missions_per_project',
    'max_objectives_per_mission',
    'storage_gb',
    'max_file_mb',
    'max_custom_fields',
    'max_sticky_boards',
    'max_guests',
];
export const FeatureKeys = [
    'custom_fields',
    'sticky_boards',
    'calendar_view',
    'custom_roles',
    'custom_domain',
    'remove_powered_by_devninjaweb',
    'web_push',
    'data_export',
    'api_access',
];
export const EntitlementKeys = [...LimitKeys, ...FeatureKeys];
//# sourceMappingURL=enums.js.map